<script>
    import Accordion from '../../shared/Accordion.svelte'
    import Issues    from '../../shared/Issues.svelte'
    import Question  from './Question.svelte'

    export let item
    export let domain

    let active = -1
    let mode = null
    let archetype = empty()

    function empty() {
        return { 
            id          : 0    , /*  required */
            required    : false, /*  required */
            key         : null , /*  required */
            description : null , /*  required */ 
            text        : null ,
            minLen      : null ,
            maxLen      : null ,
            htmlType    : null ,
            pattern     : null ,
        }
    }

    function cancel() {
        mode = null
        archetype = empty()
        active = -1
    }

    function update(evt) {
        const constraint = evt.detail
        const tmp = item.constraints.filter(it => it.id !== constraint.id)
        item.constraints = [...tmp, constraint]
        cancel()
    }

    function remove(evt) {
        const constraint = evt.detail
        item.constraints = item.constraints.filter(it => it.id !== constraint.id)
        cancel()
    }

    $: buffer = item.constraints
    $: issues = item.issues

</script>
<div class="top">
    {#if issues.length > 0}
        <div class="ui basic segment">
            <Issues {issues}>
                Problemas:
            </Issues>
        </div>
    {/if}
    <h3 class="ui header">Perguntas</h3>
    {#if mode === 'add'}
        <Question {domain} profile={item} bind:item={archetype} on:cancel={cancel} on:update={update}></Question>
    {:else}
        <div class="ui right aligned basic segment">
            <button class="ui blue button" on:click={() => mode = 'add'}>
                Adicionar
            </button>
        </div>
        {#if buffer.length > 0}
            <Accordion items={buffer} bind:active>
                <div slot="title" let:item={i}>
                    <i class="dropdown icon"></i> {i.description}
                </div>
                <div slot="content" let:item={i}>
                    <Question {domain} profile={item} item={i} on:update={update} on:remove={remove}></Question>
                </div>    
            </Accordion>
        {/if}
    {/if}
</div>
<style>
    .top {
        margin: 2em 1em;
    }
    div[slot="title"] {
        font-size: 1.1em;
    }
</style>

